import { atom } from 'jotai';

/**
 * enable additional index or dot for End Recommendation Section
 */
export const $EnableIndexForRecommend = atom(false);
